var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuplicateItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 26.897,
    viewBox: "0 0 20 26.897",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(0 26.897)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M20-26.9H2.414v2.414H0V0H17.586V-2.414H20ZM16.9-.69H.69v-23.1H16.9ZM19.31-3.1H17.586V-24.483H3.1v-1.724H19.31Z",
    fill: "#00b3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M3.1-18.276H14.138v-.69H3.1Z",
    fill: "#00b3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M3.1-15.517H14.138v-.69H3.1Z",
    fill: "#00b3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M3.1-12.759H14.138v-.69H3.1Z",
    fill: "#00b3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M3.1-10H14.138v-.69H3.1Z",
    fill: "#00b3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M3.1-7.241H14.138v-.69H3.1Z",
    fill: "#00b3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M3.1-4.483H14.138v-.69H3.1Z",
    fill: "#00b3ff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicateItem);
export default __webpack_public_path__ + "static/media/duplicateItem.4542b5692d8cc6dc83b1c30feb8b791c.svg";
export { ForwardRef as ReactComponent };